module Meevo.Plugins.SmartCenter {
    export class SmartTileNames {
        public static menuShortcut: string = 'MenuShortcut';
        public static appointmentServices: string = 'AppointmentServices';
        public static estimatedSales: string = 'EstimatedSales';
        public static hoursNotSold: string = 'HoursNotSold';
        public static newClientsWithAppointments: string = 'NewClientsWithAppointments';
        public static clientsWithAppointments:string = 'ClientsWithAppointments';
        public static clientsRunningLate: string = 'ClientsLateForAppointments';
        public static appointments: string = 'Appointments';
        public static rebookedAppointments: string = 'RebookedAppointments';
        public static noShowAppointments: string = 'NoShowAppointments';
        public static percentageBooked: string = 'PercentageBooked';
        public static netSales: string = 'NetSales';
        public static averageSales: string = 'AverageSales';
        public static serviceAddonsToday: string = 'ServiceAddonsToday';
        public static appointmentsToReschedule: string = 'AppointmentsToReschedule';
        public static appointmentCount: string = 'AppointmentCount';
        public static topServicesPerformed: string = 'TopServicesPerformed';
        public static topServicesBooked: string = 'TopServicesBooked';
        public static todaysWaitList: string = 'TodaysWaitList';
        public static ratingTile: string = 'FiveStarRating';
        public static membershipConversion: string = 'MembershipConversion';
        public static monthlyRecurringRevenue: string = 'MonthlyRecurringRevenue';
        public static сhurnMonthlyRecurringRevenue: string = 'ChurnMonthlyRecurringRevenue';
        public static expansionMonthlyRecurringRevenue: string = 'ExpansionMonthlyRecurringRevenue';
        public static growthMonthlyRecurringRevenue: string = 'GrowthMonthlyRecurringRevenue';
        public static rebookedServices: string = 'RebookedServices';
        public static clientBirthdayOrAnniversary: string = 'ClientBirthdayOrAnniversary';
        public static countOfCurrentMemberships: string = 'CountOfCurrentMemberships';
        public static employeeBirthdayAnniversary: string = 'EmployeeBirthdayAnniversary';
        public static dateCounter: string = 'DateCounter';
        public static serviceCategorySales: string = 'ServiceCategorySales';
        public static productCategorySales: string = 'ProductCategorySales';
        public static serviceProviderRequests: string = 'ServiceProviderRequests';
        public static retailUnitsSales: string = 'RetailUnitsSales';
        public static membershipsSold: string = 'MembershipsSold';
        
        }
}
